<template>
<div class="furniture-transport">
  <div class="furniture-transport__basic-services">
    <div class="furniture-transport__basic-services__content">
      {{ $t('advice.fixedAdvices.serviceOfferServices.content') }}
    </div>
  </div>
  <input-label :text="$t('services.cartons.label')" />
  <input-selector v-model="cartonsSync" :options="cartonsOptions" button-class="selection-button"/>
    <next-transition :visible="cartonsSync !== null">
      <input-label :text="$t('services.wardrobesBox.label')" />
      <input-selector v-model="wardrobesSync" :options="wardrobesBoxOptions"
                      button-class="selection-button"/>
    </next-transition>
    <next-transition :visible="wardrobesSync !== null">
      <input-label :text="$t('services.mount.label')" />
      <input-selector v-model="mountSync" :options="disassemblyOptions" />
    </next-transition>
    <next-transition
      :visible="cartonsSync !== null && wardrobesSync !== null && mountSync !== null">
      <input-label :text="$t('services.fragile.label')" />
      <input-selector v-model="fragileSync" :options="fragileOptions" />
    </next-transition>
    <next-transition :visible="fragileSync !== null">
      <input-label :text="$t('services.notFragile.label')" />
      <input-selector v-model="notFragileSync" :options="notFragileOptions" />
    </next-transition>
</div>
</template>

<script>
import InputSelector from '@/components/utils/InputSelector.vue';
import InputLabel from '@/components/utils/InputLabel.vue';
import NextTransition from '@/components/utils/NextTransition.vue';


export default {
  name: 'services',
  components: {
    NextTransition,
    InputLabel,
    InputSelector,
  },
  computed: {
    cartonsSync: {
      get() {
        return this.$store.getters['serviceOfferStore/cartons'];
      },
      set(cartons) {
        this.$store.commit('serviceOfferStore/SET_CARTONS', cartons);
      },
    },
    wardrobesSync: {
      get() {
        return this.$store.getters['serviceOfferStore/wardrobes'];
      },
      set(wardrobes) {
        this.$store.commit('serviceOfferStore/SET_WARDROBES', wardrobes);
      },
    },
    mountSync: {
      get() {
        return this.$store.getters['serviceOfferStore/mount'];
      },
      set(mount) {
        this.$store.commit('serviceOfferStore/SET_MOUNT', mount);
      },
    },
    fragileSync: {
      get() {
        return this.$store.getters['serviceOfferStore/fragile'];
      },
      set(fragile) {
        this.$store.commit('serviceOfferStore/SET_FRAGILE', fragile);
      },
    },
    notFragileSync: {
      get() {
        return this.$store.getters['serviceOfferStore/unbreakable'];
      },
      set(unbreakable) {
        this.$store.commit('serviceOfferStore/SET_UNBREAKABLE', unbreakable);
      },
    },
    yes() {
      return [
        {
          label: this.$t('base.yes'),
          value: true,
        },
      ];
    },
    cartonsOptions() {
      return [
        ...this.yes,
        {
          label: this.$t('services.cartons.options.no'),
          value: false,
        },
      ];
    },
    wardrobesBoxOptions() {
      return [
        ...this.yes,
        {
          label: this.$t('services.wardrobesBox.options.no'),
          value: false,
        },
      ];
    },
    disassemblyOptions() {
      return [
        ...this.yes,
        {
          label: this.$t('services.mount.options.no'),
          value: false,
        },
      ];
    },
    fragileOptions() {
      return [
        ...this.yes,
        {
          label: this.$t('services.fragile.options.no'),
          value: false,
        },
      ];
    },
    notFragileOptions() {
      return [
        ...this.yes,
        {
          label: this.$t('services.notFragile.options.no'),
          value: false,
        },
      ];
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep{
  .selection-button{
    max-width: 200px;
    @media all and (min-width: 375px){
      max-width: unset;
    }
  }
}

.furniture-transport {

  &__basic-services {
    font-size:  $--font-size-small;
    font-style: italic;
    padding: 16px 0;
    border-bottom: 1px solid $--color-light-grey-blue;;

    @include breakpoint(desktop){
      display: none;
    }
  }

}

</style>
